import { useMemo } from 'react';

import type { Brand } from '~/types/user';

import { useUser } from '~/api/user';
import { AlertDialog, useTable } from '~/components';

import { useBrandsTableColumns } from './BrandsTable.hooks';
import { ConfirmDeleteBrandDialog } from './ConfirmDeleteBrandDialog';

export const BrandsTable = () => {
  const { data: user } = useUser();

  const deleteBrandHandle = AlertDialog.useHandle<Brand>();
  const dialogHandles = useMemo(() => ({ deleteBrandHandle }), [deleteBrandHandle]);

  const columns = useBrandsTableColumns({ dialogHandles });

  const [table, Table] = useTable({ data: user.brands, columns });

  return (
    <>
      <Table.Root table={table}>
        <Table.Menu>
          <Table.Search />
        </Table.Menu>

        <Table.Grid>
          <Table.Header />
          <Table.Body>{(row) => <Table.Row row={row} />}</Table.Body>
        </Table.Grid>

        <Table.Pagination />
      </Table.Root>

      <AlertDialog.Root handle={deleteBrandHandle}>
        {({ payload: brand }) => brand && <ConfirmDeleteBrandDialog brand={brand} onClose={() => deleteBrandHandle.close()} />}
      </AlertDialog.Root>
    </>
  );
};
